export const SHIPPING_ADDRESS_FIELDS = [
    'address1',
    'postalCode',
    'countryCode',
    'city',
    'stateOrProvince',
    'stateOrProvinceCode',
];
